import { createFileRoute } from '@tanstack/react-router';
import { MembersPage } from '@/features/organization/members/members-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/members')({
    staticData: { crumbs: [{ label: 'settings.nav.members' }] },
    component: function MembersRoute() {
        const { organizationId } = Route.useParams();
        return <MembersPage organizationId={organizationId} />;
    },
});
